
<div class="page-container" style="min-height:188.38330078125px">
  <!--Page content -->
  <div  class="page-content">
    <div *ngIf="true" >
      <div class="file-info-header">
        <h5>{{ translate.instant('File Information')}}</h5>
      </div>
      <div class="file-info-body">
        <div class="form-horizontal">
          <div class="form-group">
            <label class="control-label col-md-2 col-sm-2 col-xs-3"><strong>{{translate.instant( 'File Name' ) }}</strong></label>
            <div class="col-md-10 col-sm-10 col-xs-9">
              <p class="form-control-static">{{ theJob?.name }}</p>
            </div>
          </div>
          <div class="form-group">
            <label class="control-label col-md-2 col-sm-2 col-xs-3"><strong>{{ translate.instant('File Size') }}</strong></label>
            <div class="col-md-10 col-sm-10 col-xs-9">
              <p class="form-control-static">{{ theDocument?.size === 0 ? 1 : theDocument?.size }} KB</p>
            </div>
          </div>
          <!-- file creation date -->
          <div class="form-group">
            <label class="control-label col-md-2 col-sm-2 col-xs-3"><strong>{{ translate.instant('File Created Date') }}</strong></label>
            <div class="col-md-10 col-sm-10 col-xs-9">
              <p class="form-control-static">{{ theDocument?.created | date: 'dd/MM/yyyy' }}</p>
          </div>
          <div class="form-group">
            <label class="control-label col-md-2 col-sm-2 col-xs-3"><strong>{{ translate.instant( 'Signature Type' ) }}</strong></label>
            <div class="col-md-10 col-sm-10 col-xs-9">
              <p class="form-control-static">
                <strong *ngIf="theJob?.signature === 'P'">PADES LTA</strong>
                <strong *ngIf="theJob?.signature === 'C_DET'">CADES Detached</strong>
                <strong *ngIf="theJob?.signature === 'C_ENV'">CADES Enveloping</strong>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="file-info-footer text-right">
        <button class="btn btn-primary" (click)="downloadFile()">{{ translate.instant( 'Download' ) }}</button>
      </div>
    </div>

  </div>
</div>

<!-- Unified Digital Signer Modal Component -->
<app-digital-signer-modal
  #digitalSignerModal
  [requestCode]="requestCode"
  [theJob]="theJob"
  [theRecipient]="theRecipient"
  [signReturnURL]="signReturnURL"
  [enabledMethods]="['usb', 'mobile']"
  [showReasonLocation]="false"
  (signComplete)="onSignComplete($event)"
  (signCancelled)="onSignCancelled()"
  (signRejected)="onSignRejected()">
</app-digital-signer-modal>
